import { render, staticRenderFns } from "./violationsGridBlock.vue?vue&type=template&id=3ca28262&scoped=true"
import script from "./violationsGridBlock.vue?vue&type=script&lang=js"
export * from "./violationsGridBlock.vue?vue&type=script&lang=js"
import style0 from "./violationsGridBlock.vue?vue&type=style&index=0&id=3ca28262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca28262",
  null
  
)

export default component.exports